const translations = {
  en: {
    depositUsing: 'Deposit using',
    paypalNotice: 'To use PayPal as a deposit method, customers must first ensure that funds are available in their PayPal account. <b>Add money to your PayPal balance</b> before attempting to make a deposit.',
    applePayNotice: 'To successfully use Google Pay or Apple Pay for deposits, the <b>billing address on your Apple/Google Pay account must match the address listed </b> on your customer account. Please verify this information before proceeding with a deposit.',
    moonPayNotice: 'Before using MoonPay for deposits, customers are required to complete a one-time KYC (Know Your Customer) verification process. This process includes:',
    moonPayItem1: 'Uploading a valid picture ID',
    moonPayItem2: 'Completing a biometric scan',
    moonPayItem3: 'Providing your Social Security Number (SSN) For US customers only',
    loadingForm: 'Please wait, your form will load in a few seconds...',
    secureId: 'SecureID:',
    secureIdPlaceholder: 'SecureID',
    account: 'Account:',
    accountPlaceholder: 'Account',
    currency: 'Currency',
    amountPlaceholder: 'Enter amount here',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    zelleImportantTitle: 'IMPORTANT',
    zelleImportantText: 'Zelle deposits are processed daily from 8:00 AM to 10:00 PM ET. Requests submitted outside these hours will be processed after 8:00 AM ET.',
    back: 'BACK',
    deposit: 'DEPOSIT',
    processing: 'Processing...',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    depositPending: 'Deposit Pending',
    depositCompleted: 'eWallet Deposit Completed',
    depositRejected: 'eWallet Deposit Rejected',
    depositWithError: 'Error with eWallet Deposit',
    errorMakingDeposit: 'Error making deposit',
    address: 'Address',
    paycashRefStart: 'Your Paycash reference number is:',
    paycashRefEnd: 'Once the deposit is completed, your balance will be updated.',
    pleaseDeposit: 'Please deposit the following btc amount:',
  },
  es: {
    depositUsing: 'Depositar usando',
    paypalNotice: 'Para usar PayPal como método de depósito, los clientes deben asegurarse primero de que haya fondos disponibles en su cuenta de PayPal. <b>Agregue dinero a su saldo de PayPal</b> antes de intentar realizar un depósito.',
    applePayNotice: 'Para usar Google Pay o Apple Pay para depósitos correctamente, la <b>dirección de facturación en su cuenta de Apple/Google Pay debe coincidir con la dirección registrada</b> en su cuenta de cliente. Verifique esta información antes de proceder con un depósito.',
    moonPayNotice: 'Antes de usar MoonPay para depósitos, los clientes deben completar un proceso de verificación KYC (Conozca a su Cliente) por única vez. Este proceso incluye:',
    moonPayItem1: 'Subir una identificación con foto válida',
    moonPayItem2: 'Completar un escaneo biométrico',
    moonPayItem3: 'Proporcionar su Número de Seguro Social (SSN) - Solo para clientes de EE.UU.',
    loadingForm: 'Por favor espere, su formulario cargará en unos segundos...',
    secureId: 'SecureID:',
    secureIdPlaceholder: 'SecureID',
    account: 'Cuenta:',
    accountPlaceholder: 'Cuenta',
    currency: 'Moneda',
    amountPlaceholder: 'Ingrese el monto aquí',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    zelleImportantTitle: 'IMPORTANTE',
    zelleImportantText: 'Los depósitos de Zelle se procesan diariamente de 8:00 AM a 10:00 PM ET. Las solicitudes enviadas fuera de este horario se procesarán después de las 8:00 AM ET.',
    back: 'ATRÁS',
    deposit: 'DEPOSITAR',
    processing: 'Procesando...',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    depositPending: 'Depósito Pendiente',
    depositCompleted: 'Depósito eWallet Completado',
    depositRejected: 'Depósito eWallet Rechazado',
    depositWithError: 'Error con el Depósito eWallet',
    errorMakingDeposit: 'Error al realizar el depósito',
    address: 'Dirección',
    paycashRefStart: 'Su número de referencia Paycash es:',
    paycashRefEnd: 'Una vez completado el depósito, su saldo será actualizado.',
    pleaseDeposit: 'Por favor deposite la siguiente cantidad de btc:',
  },
  pt: {
    depositUsing: 'Depositar usando',
    paypalNotice: 'Para usar PayPal como método de depósito, os clientes devem primeiro garantir que há fundos disponíveis em sua conta PayPal. <b>Adicione dinheiro ao seu saldo PayPal</b> antes de tentar fazer um depósito.',
    applePayNotice: 'Para usar Google Pay ou Apple Pay para depósitos com sucesso, o <b>endereço de cobrança na sua conta Apple/Google Pay deve corresponder ao endereço listado</b> na sua conta de cliente. Verifique essas informações antes de prosseguir com um depósito.',
    moonPayNotice: 'Antes de usar o MoonPay para depósitos, os clientes devem completar um processo único de verificação KYC (Know Your Customer). Este processo inclui:',
    moonPayItem1: 'Upload de uma identificação com foto válida',
    moonPayItem2: 'Completar uma verificação biométrica',
    moonPayItem3: 'Fornecer seu Número de Segurança Social (SSN) - Apenas para clientes dos EUA',
    loadingForm: 'Por favor aguarde, seu formulário carregará em alguns segundos...',
    secureId: 'SecureID:',
    secureIdPlaceholder: 'SecureID',
    account: 'Conta:',
    accountPlaceholder: 'Conta',
    currency: 'Moeda',
    amountPlaceholder: 'Insira o valor aqui',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    zelleImportantTitle: 'IMPORTANTE',
    zelleImportantText: 'Depósitos Zelle são processados diariamente das 8:00 AM às 10:00 PM ET. Solicitações enviadas fora deste horário serão processadas após as 8:00 AM ET.',
    back: 'VOLTAR',
    deposit: 'DEPOSITAR',
    processing: 'Processando...',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    depositPending: 'Depósito Pendente',
    depositCompleted: 'Depósito eWallet Concluído',
    depositRejected: 'Depósito eWallet Rejeitado',
    depositWithError: 'Erro com Depósito eWallet',
    errorMakingDeposit: 'Erro ao realizar o depósito',
    address: 'Endereço',
    paycashRefStart: 'Seu número de referência Paycash é:',
    paycashRefEnd: 'Após a conclusão do depósito, seu saldo será atualizado.',
    pleaseDeposit: 'Por favor deposite o seguinte valor em btc:',
  },
}

export default translations
